import Routes from 'router/Routes';
import './App.scss';

const App = (): JSX.Element => {
  return <Routes />;
};

export default App;
